import React from 'react'
import { Helmet } from 'react-helmet-async'

interface PreloadedImageProps {
  widthImage?: string
  mobileSrc: string
  desktopSrc: string
  isMobile: boolean
  mobileAspectRatio: string
  desktopAspectRatio: string
  alt?: string
}

const PreloadedImage = ({
  widthImage,
  mobileSrc,
  desktopSrc,
  isMobile,
  mobileAspectRatio,
  desktopAspectRatio,
  alt,
}: PreloadedImageProps) => {
  return (
    <>
      <Helmet>
        <link
          rel="preload"
          as="image"
          href={isMobile ? mobileSrc : desktopSrc}
        />
      </Helmet>
      {isMobile ? (
        <img
          src={mobileSrc}
          style={{ width: widthImage, aspectRatio: `${mobileAspectRatio}` }}
          alt={alt ?? ''}
          loading="eager"
        />
      ) : (
        <img
          src={desktopSrc}
          style={{ width: widthImage, aspectRatio: `${desktopAspectRatio}` }}
          alt={alt ?? ''}
          loading="eager"
        />
      )}
    </>
  )
}

export default PreloadedImage
